import React, { useContext, useState } from "react";
import AudioInput from "./artifacts/create/AudioInput";
import VideoInput from "./artifacts/create/VideoInput";
import ActionPopup from "../components/ActionPopup";
import { ActionItem, SKDocumentArtifact, SKGreetingArtifact } from "../models/SKArtifact";
import { SKSelectOption } from "../components/SKSelectOption";
import { SKRadioOption } from "../components/SKRadioOption";
import { CreateArtifactContext } from "../context/CreateArtifactContext";
import { useNavigate } from "react-router-dom";
import ImageInput from "./artifacts/create/ImageInput";
import { AddPlaceField } from "./artifacts/create/container/components/AddPlaceField";
import { AddContentItem } from "./artifacts/create/container/components/AddContentItem";
import { AddTextField } from "./artifacts/create/container/components/AddTextField";
import { DateTimePicker } from "./artifacts/create/container/DateTimePicker";
import DocumentInput from "./artifacts/create/DocumentInput";
import { Timestamp } from "firebase/firestore";
import { AllMediaInput } from "./artifacts/create/container/components/AllMediaInput";
import AddImageWithText from "./artifacts/create/container/components/AddImageWithText";
import { AddStickyNote } from "./artifacts/create/container/components/AddStickyNote";
import MultiTypeInVisibleInput from "./artifacts/create/MultiTypeInVisibleInput";
import { FolderName, SKMediaType } from "../api/shared/uploadService";
import { SKURLWidget } from "./artifacts/create/container/components/SKURLWidget";
import { AddTextAreaField } from "./artifacts/create/container/components/AddTextAreaField";
import SKCustomSelect, { SKCustomOption } from "../components/SKCustomSelect";
import SKPagination from "../components/SKPagination";
import PopupSingleButtonProps, { PopupActionStatus } from "../components/PopupSingleButton";
import PopupDoubleButtonProps from "../components/PopupDoubleButton";
import PopupMultiActionProps from "../components/PopupMultiAction";

export const WidgetShowcase: React.FC = () => {
  const [radioValue, setRadioValue] = useState("None");
  const [selectValue, setSelectValue] = useState("None");
  const { contentData, artifactId } = useContext(CreateArtifactContext);
  const [coverImage, setCoverImage] = useState<string>("");
  const [coverImageIsEnable, setCoverImageIsEnable] = useState<boolean>(false);
  const [location, setLocation] = useState<string>("");
  const [locationIsEnable, setlocationIsEnable] = useState<boolean>(false);
  const [title, settTitle] = useState<string>("");
  const [titleIsEnable, setTitleIsEnable] = useState<boolean>(false);
  const [documentPath, setDocumentPath] = useState<string>("");
  const [webURL, setWebURL] = useState<string>("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const navigate = useNavigate();
  const handleImageChange = (index: number, fileUrl: string | null) => {
    setCoverImage(fileUrl ?? "");
    setCoverImageIsEnable(fileUrl ? true : false);
  };
  const handlePlaceChange = (newPlace: string) => {
    setLocation(newPlace);
    setlocationIsEnable(newPlace ? true : false);
  };

  const handleStartDateChange = (date: Date | undefined) => {};

  const handleEndDateChange = (date: Date | undefined) => {};

  const handleFileChange = (fileUrl: string | null) => {
    setDocumentPath(fileUrl ?? "");
  };

  return (
    <div className="p-4 h-[calc(100vh-4rem)] overflow-y-auto bg-white">
      <h1 className="mb-4 text-2xl font-bold">Component Showcase</h1>
      <table className="w-full">
        <tbody>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{0}</div>
                  <span className="content_title">PopupDialogOk.tsx</span>
                  <button
                    className={
                      " flex bg-black items-center justify-center px-3 py-1 text-sm font-normal text-center text-white rounded-lg flex-shrink-0 h-32px"
                    }
                    onClick={async () => {
                      setIsPopupVisible(true);
                    }}
                  >
                    Show Popup
                  </button>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  {isPopupVisible && (
                    <PopupSingleButtonProps
                      popupContent={{
                        title: "Successfully Submitted ",
                        message: "Your channel is successfully submitted for review.",
                        buttonTitle: "OK",
                        status: PopupActionStatus.success,
                      }}
                      onClose={async () => {
                        alert("Closing");
                        setIsPopupVisible(false);
                      }}
                    />
                  )}
                  {/* {isPopupVisible && (
                    <PopupDoubleButtonProps
                      popupContent={{
                        title: "Are you sure you will like to Delete Channel?",
                        message:
                          "Permanently delete this channel. This action cannot be undone.",
                        cancelButtonTitle: "Cancel",
                        actionButtonTitle: "Delete Channel",
                      }}
                      onClose={async () => {
                        alert("Moving");
                        setIsPopupVisible(false);
                      }}
                      onActionClick={async () => {
                        alert("Action Taken");
                        setIsPopupVisible(false);
                      }}
                    />
                  )} */}
                  {/* {isPopupVisible && (
                    <PopupMultiActionProps
                      popupContent={{
                        title: "Are you sure you will like to Reject Channel?",
                        message:
                          "This channel will not be published to the user.",
                        cancelButtonTitle: "Cancel",
                        actionButtonTitle: "Reject Channel",
                      }}
                      onClose={async () => {
                        alert("Moving");
                        setIsPopupVisible(false);
                      }}
                      onActionClick={async () => {
                        alert("Action Taken");
                        setIsPopupVisible(false);
                      }}
                    />
                  )} */}
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-5">
                  <div className="content_count">{1}</div>
                  <span className="content_title">ImageInput.tsx</span>
                  <button
                    className={
                      (coverImageIsEnable ? "bg-black" : "bg-gray-400 disabled-link") +
                      " flex items-center justify-center px-3 py-1 text-sm font-normal text-center text-white rounded-lg flex-shrink-0 h-32px"
                    }
                    onClick={async () => {
                      setCoverImage("");
                      setCoverImageIsEnable(false);
                    }}
                  >
                    clear
                  </button>
                </div>
                <div className="flex items-center w-3/5">
                  <ImageInput
                    key={0}
                    index={0}
                    onFileChange={handleImageChange}
                    docId={artifactId!}
                    maxFileSize={5}
                    imageUrl={coverImage}
                    folder={FolderName.content}
                    fileTypeShow="JPG, PNG, or HEIF"
                    imageWidth={180}
                    imageHeight={180}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{2}</div>
                  <span className="content_title">AddPlaceField.tsx</span>
                  <button
                    className={
                      (locationIsEnable ? "bg-black" : "bg-gray-400 disabled-link") +
                      " flex items-center justify-center px-3 py-1 text-sm font-normal text-center text-white rounded-lg flex-shrink-0 h-32px"
                    }
                    onClick={async () => {
                      setLocation("");
                      setlocationIsEnable(false);
                    }}
                  >
                    clear
                  </button>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AddPlaceField
                    name={"addplace"}
                    title={"Location Search"}
                    note={"Location Search"}
                    placeholder={"Search Place"}
                    index={1}
                    isVisible={true}
                    value={location}
                    onChange={handlePlaceChange}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{3}</div>
                  <span className="content_title">AddContentItem.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AddContentItem
                    index={1}
                    onClick={() => {
                      alert("It will Navigation to the Screen where user can add the items.");
                      navigate("#");
                    }}
                    count={true ? 1 : 0}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{4}</div>
                  <span className="content_title">DocumentInput.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <DocumentInput
                    docId={"101"}
                    onFileChange={handleFileChange}
                    documentUrl={documentPath}
                    maxFileSize={10}
                    editable={true}
                    folder={FolderName.content}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{5}</div>
                  <span className="content_title">DateTimePicker.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <DateTimePicker
                    startNote={"Start date and time of the event."}
                    endNote={"End date and end time of the event. Leave blank if not needed."}
                    onStartDateChanged={handleStartDateChange}
                    onEndDateChanged={handleEndDateChange}
                    startTimestamp={Timestamp.now()}
                    endTimestamp={Timestamp.now()}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{6}</div>
                  <span className="content_title">AddTextField.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AddTextField
                    name={"addtitle"}
                    title={"Add Title"}
                    note={"Add Title"}
                    placeholder={"Enter Title"}
                    index={1}
                    charAllowed={50}
                    value={title}
                    isCloseBtn={true}
                    disabled={false}
                    onChange={async e => {
                      settTitle(e.target.value);
                      e.target.value.length >= 1 ? setTitleIsEnable(true) : setTitleIsEnable(false);
                    }}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{7}</div>
                  <span className="content_title">AudioInput.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AudioInput
                    onFileChange={url => {
                      console.log(url);
                    }}
                    docId="testId"
                    removeAudio={() => {}}
                    folder={FolderName.content}
                    maxAudioDuration={5400} // 90 minutes
                    maxFileSize={50} // 50 MB
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{8}</div>
                  <span className="content_title">VideoInput.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <VideoInput
                    onFileChange={url => {
                      console.log(url);
                    }}
                    docId="testId"
                    folder={FolderName.content}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{9}</div>
                  <span className="content_title">ActionPopup.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <ActionPopup
                    getValues={() => [ActionItem.approve, ActionItem.delete]}
                    onSelect={val => {
                      console.log(val);
                    }}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{10}</div>
                  <span className="content_title">SKSelectOption.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <SKSelectOption
                    value={selectValue}
                    heading="Headig"
                    subHeading="Sub Heading"
                    index={1}
                    options={[
                      { title: "Option-1", value: "Option1" },
                      { title: "Option-2", value: "Option2" },
                      { title: "Option-3", value: "Option3" },
                    ]}
                    onUpdate={e => setSelectValue(e.target.value)}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{11}</div>
                  <span className="content_title">SKCustomSelect.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <SKCustomSelect
                    id="secondaryExternalLink"
                    name="secondaryExternalLink2"
                    //value={secondaryLink}

                    onOptionSelect={async e => {
                      const { name, value } = e.target;
                    }}
                  >
                    {Array.from({ length: 5 }, (_, i) => i + 1).map(number => (
                      <SKCustomOption key={number} value={"item.value " + number}>
                        {"item.value " + number}
                      </SKCustomOption>
                    ))}
                  </SKCustomSelect>
                </div>
              </div>
            </td>
          </tr>
          {/* <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">
                    {12}
                  </div>
                  <span className="content_title">SKRadioOption.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <SKRadioOption
                    value={radioValue}
                    heading="Headig"
                    subHeading="Sub Heading"
                    index={2}
                    options={[
                      { title: "Option-1", value: "Option1" },
                      { title: "Option-2", value: "Option2" },
                      { title: "Option-3", value: "Option3" },
                    ]}
                    onChange={(val) => setRadioValue(val)}
                  />
                </div>
              </div>
            </td>
          </tr> */}
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{12}</div>
                  <span className="content_title">AllMediaInput.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AllMediaInput
                    name={"Add Cover Video or Audio"}
                    index={5}
                    note={"Choose a video or audio that represents the topic, purpose or title of the post."}
                    docId={(contentData as SKDocumentArtifact).id}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{13}</div>
                  <span className="content_title">AddImageWithText.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <div className="flex items-center">
                    <span className="content_title">Greeting Card Preview</span>
                    <AddImageWithText text={"Birthday Wishes"} innerImage={"/images/greetings/birthday.png"} />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{14}</div>
                  <span className="content_title">AddStickyNote.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AddStickyNote
                    key={1}
                    text={"Sample sticky notes.     ."}
                    onDelete={function (): void {
                      throw new Error("Function not implemented.");
                    }}
                    onEdit={function (): void {
                      throw new Error("Function not implemented.");
                    }}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{15}</div>
                  <span className="content_title">MultiTypeInVisibleInput.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <MultiTypeInVisibleInput
                    index={1}
                    docId={artifactId!}
                    maxFileSize={5}
                    editable={true}
                    onFileChange={function (index: number, fileUrl: string, fileType: SKMediaType): void {
                      throw new Error("Function not implemented.");
                    }}
                    imageUrl={""}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{16}</div>
                  <span className="content_title">SKURLWidget.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <SKURLWidget
                    id={"primaryExternalLink"}
                    name={""}
                    title={""}
                    note={""}
                    placeholder={"Add Link"}
                    charAllowed={50}
                    value={webURL}
                    isCloseBtn={false}
                    onChange={async e => {
                      setWebURL(e.target.value);
                    }}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{17}</div>
                  <span className="content_title">AddTextAreaField.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <AddTextAreaField
                    name={"addtext"}
                    title={"Add Text"}
                    note={"Maximum text length of 500 characters."}
                    placeholder={"Enter Text"}
                    index={3}
                    height={150}
                    charAllowed={500}
                    value={""}
                    onChange={async e => {}}
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr className="border-b">
            <td className="p-4">
              <div className="flex gap-[5px]">
                <div className="flex items-center w-2/5 space-x-2">
                  <div className="content_count">{18}</div>
                  <span className="content_title">SKPagination.tsx</span>
                </div>
                <div className="w-3/5 items-center gap-[5px]">
                  <SKPagination onFirst={() => {}} onNext={() => {}} onPrev={() => {}} onLast={() => {}} hasNext={true} hasPrev={true} />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
